module.exports = __webpack_public_path__ + "img/ru-gok.48fe21b.png";